import Joi from 'joi'

const ValidationSchema = Joi.object({
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .required()
    .label('Email'),
})

export default ValidationSchema
